const ar = {
    common: {
      or: 'أو',
      cancel: 'إلغاء',
      reset: 'إلغاء',
      save: 'حفظ',
      search: 'بحث',
      edit: 'تعديل',
      remove: 'إزالة',
      new: 'جديد',
      export: 'تصدير إلى Excel',
      noDataToExport: 'لا توجد بيانات للتصدير',
      import: 'استيراد',
      discard: 'تجاهل',
      yes: 'نعم',
      no: 'لا',
      pause: 'توقف',
      areYouSure: 'هل أنت متأكد للإزالة ؟',
      view: 'عرض',
      destroy: 'حذف',
      mustSelectARow: 'يجب إختيار صف',
      confirm: 'تأكيد ',
      submit:'تأكيد',
      privacy: 'سياسة',
      policy: 'الخصوصية',
      termsAnd: 'الاحكام و',
      conditions: 'الشروط',
      privacyPolicy: 'سياسة الخصوصية',
      termsAndConditions: 'الشروط والأحكام',
    },

    meta: {
      title: 'خطط واجعل رحلتك أكثر بساطة',
      description: 'دعنا نجرب مغامرة جديدة لاكتشاف العالم.',
    },

    tables:{
      admins:{
        firstName:'الأسم الأول ',
        lastName:'الأسم الأخير',
        phoneNumber:'رقم الجوال',
        email:'البريد الإلكتروني',
        role:'الدور',
        createdAt:'إنشاء فى',
        status:'الحالة',
        action:'الامر ',
        placeName:'إسم الموقع',
        search:'بحث' ,
        submit:'تأكيد'
      },
      users:{
  
      }
  
    },


  saryahLanding : {


    splash : 'جاري التحميل ... ' ,

    header:
    {
      home:'الرئيسية',
      aboutUs :'عن سارية ' ,
      Services :'خدماتنا' ,
      ContactUs :' تواصل معنا  ' ,
      saryahHead : 'سارية ، خطط لرحلتك بسهولة',
      saryahContent : 'مغامرة جديدة لإكتشاف العالم' ,
      viewMore : 'شاهد المزيد '
    },
    about:{
      aboutTiltle: 'ما هى سارية ؟ ' ,
      aboutSecOne: 'سارية عبارة عن منصة الكترونية تقوم بمساعدة المسافرين على إيجاد أنشطة ترفيهية و أماكن سياحية لمعرفة الثقافة الأصيلة لها وتساعدهم أيضًا على التواصل مع المرشدين السياحيين المحترفين وشركات السياحة من خلال تسجيل معلوماتهم الشخصية ومهاراتهم وخدماتهم و خبراتهم للحصول على مزيد من المعلومات والمميزات ولتحديد مسارات الرحلة بشكل أوضح' ,
      aboutSecTwo :' يمكن  للمسافرين الإختيار من بين الآلاف من المرشدين السياحيين بناء على الأنسب لمتطلباتهم ، يعتبر سارية  أداة سفر فعالة للمسافرين الذين يكتشفون العالم.' ,
      
    } ,

    saryahClient: {
      bookmark: 'تطبيق سارية للعميل' ,
      head : 'خطط، أحجز و اكتشف رحلتك لأكتساب المزيد من المعرفة.' ,
      location : 'إختر موقعك الحالي ' ,
      tourGuid : 'إختر مرشدك السياحي' ,
      tripPlan : 'إختر خطة رحلتك ' ,
      downloadMobile : 'حمل تطبيق سارية الآن' ,
      
    },

    saryahTour : {
      head : 'تطبيق سارية للمرشد السياحي' , 
      content : 'تواصل مع المسافرين بسهولة لمساعدتهم في شرح المزيد من المعلومات والمميزات حول الأماكن واكتشاف الأجزاء الأكثر اهتماما في رحلاتهم.' ,
      downloadMobile : ' حمل تطبيق سارية الآن' ,
    },

    footer : {
      about : 'عنا' ,
      aboutContent : 'سارية  هو تطبيق للجوال يساعدك في العثور على أماكن مثيرة بالإضافة إلى الأنشطة والأشياء التي يمكنك القيام بها مع المرشدين السياحيين المحليين المحترفين من القطاع الخاص أو في مجموعة وأيضًا البحث عن الأماكن المحلية عن طريق تحديد المناطق القريبة منك. هذه الأماكن هي الطريقة المثالية لاستكشاف مدن جديدة والمشاركة في ثقافة محلية أصيلة.' ,
      contactUs : 'تواصل معنا ' ,
      mail : 'info@saryahapp.com' ,
      location : '7849 ، شارع الكويت ، حي الفيصلية ، جدة ، منطقة مكة المكرمة ، المملكة العربية السعودية' ,
      copyRight : 'جميع حقوق التصميم والملكية الفكرية مسجلة ومحفوظة لشركة سارية © 2020 ' , 
    }

  },
  

    metaTitle: {
      mainTitle: ' سارية ',

      signIn:'سارية | تسجيل الدخول ',
      signUp:' سارية | إنشاء حساب ',
      forgetPass: ' سارية | نسيت كلمة المرور ',
      emailUnverified:' سارية | تأكيد الحساب الشخصي',
      emptyPermissions:' سارية | إذن الدخول للحساب ',



      authDahsboard:'سارية | لوحة التحكم ' ,
      authEdit: ' سارية | تعديل الملف الشخصي ' ,
      authSetting: ' سارية | الإعدادات  ' , 
  
      admins:' سارية | قاعدة البيانات | المشرفين ',
      newAdmins:' سارية | قاعدة البيانات | المشرفين | مشرف  جديد ',
      editAdmin:' سارية | قاعدة البيانات | المشرفين | تعديل ',
      viewAdmin:' سارية | قاعدة البيانات | المشرفين | عرض  ',
  
      users:' سارية | قاعدة البيانات | العملاء ',
      viewUser:' سارية | قاعدة البيانات | العملاء | عرض  ',
  
      place:'سارية | موقع  ' ,
      newPlace: ' سارية | موقع | إضافة موقع ' ,
      editPlace:' سارية | موقع | تعديل '  ,
      viewPlace:' سارية | موقع | عرض ' ,
  
      newNotification:' سارية | موقع | الإشعارات '  ,
  
    },
  
  
    app: {
      title: 'سارية',
      ConfirmEmailAddress : 'تأكيد عنوان البريد الإلكترونى'
    },
  
    entities: {
        sideMenu:{
            dashboard:'لوحة التحكم',
            database:'قاعدة البيانات',
            users:'العملاء',
            companyProfile:'الملف الشخصي للشركة',
            TourGuides:'المرشدين السائحين',
            admins:'المشرفين',
            addLocationZone:'إضافة موقع ',
            RegisterPlaces:'المواقع المسجلة',
            Setting:'الإعدادات',
            changeLanguage:'تغيير اللغة',
            changeTheme:'تغيير لون الإطار '
        },
        dashboard:{
            projection:'تخطيط',
            visitors:'المرشدين السياحيين',
            AdminsChart:'المشرفين' ,
            usersTable:'جدول العملاء',
            adminsTable:'جدول المشرفين',
            addNewAdmin:'إضافة مشرف جديد',
            tourGuideTable:'جدول المرشدين السياحيين',
            addNewtourGuide:'إضافة مرشد جديد',
            registerPlaces:'المواقع المسجلة',
            chooseLanguage:'إختار اللغه',
            profile:'الملف الشخصي',
            Fname:'الإسم الاول',
            Lname:'الإسم الأخير',
            phoneNumber:'رقم الجوال',
            email:'البريد الإلكتروني'
            },
            splash:{
                welcome:'مرحبا بك فى لوحة التحكم الخاصة بسارية',
                getStarted:'هيا بنا نبدأ',
                LOGIN:'تسجيل الدخول',

                verifyPhone:'تأكيد رقم الجوال',
                enterPin:'من فضلك أدخل الكود المرسل إليك',

                phoneSign:'من فضلك قم بإدخال رقم الجوال لتسجيل الدخول ',
                welcBack:'مرحبا بالرجوع  ',
                loginAccount:'تسجيل الدخول الى حسابك الشخصي',
                pleaseValid:'من فضلك ادخل البريد الإلكتروني ورقم المرور لستجيل الدخول',
                orLoginWith:'أو قم بتسجيل الدخول من خلال ',
                dontHaveAccount:'ليس لديك حساب شخصي ؟'
              },
              signup:{
                linkeEmail:'إنشاء بريد إلكتروني وكلمة مرور' ,
                createNew:'إنشاء حساب جديد',
                pleaseEnter:'أدخل البريد الإلكترونى وكلمة المرور ' ,
                signUpUp:'إنشاء حساب جديد',
                enterphoneUp:'من فضلك قم بإدخال رقم الجوال لإنشاء حساب ',
                loginAccount:'تسجيل الدخول لحسابك',
                signUp:'تسجل ',
                alreadyMember:'بالفعل عضو ؟',
                signIn:' تسجيل دخول'
              },
      place: {
        name: 'place',
        label: 'المواقع',
        menu: 'المواقع',
        ADD:'إضافة',
        Next:'التالي',
        placeholder:"أدخل موقعك الحالى " ,
        exporterFileName: 'place_export',
        list: {
          menu: 'المواقع',
          title: 'المواقع',
        },
        create: {
          success: 'تم حفظ الموقع بنجاح ',
        },
        update: {
          success: 'تم حفظ الموقع بنجاح',
        },
        destroy: {
          success: 'تم مسح الموقع بنجاح',
        },
        destroyAll: {
          success: 'تم حذف المكان (المواقع) بنجاح',
        },
        edit: {
          title: 'تعديل الموقع',
        },
        fields: {
          id: 'رقم المكان',
          'lat': 'خط الطول',
          'lng': 'خط العرض ',
          'radiusRange': 'نصف القطر',
          'radius': 'نصف القطر ',
          'color': 'لون',
          'strokeColor': 'لون الدائرة',
          'strokeWidthRange': 'عرض الإطار',
          'strokeWidth': 'سمك الدائرة',
          'fillColor': 'اللون السائد',
          createdAt: 'إنشاء فى',
          updatedAt: 'تعديل فى ',
          createdAtRange: 'أنشئت في',
          'placeName':'إسم الموقع',
          'city':'المدينة',
          'country':'البلد'
        },
        enumerators: {
  
        },
        new: {
          title: 'إضافة موقع',
        },
        view: {
          title: 'عرض الموقع',
        },
        importer: {
          title: 'استيراد الأماكن',
          fileName: 'place_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },
  
      notification: {
        name: 'notification',
        label: 'Notifications',
        menu: 'Notifications',
        exporterFileName: 'notification_export',
        list: {
          menu: 'Notifications',
          title: 'Notifications',
        },
        create: {
          success: 'تم حفظ الإشعار بنجاح',
        },
        update: {
          success: 'تم حفظ الإشعار بنجاح',
        },
        destroy: {
          success: 'تم مسح الإشعار بنجاح',
        },
        destroyAll: {
          success: 'Notification(s) deleted successfully',
        },
        edit: {
          title: 'تعديل الإشعار',
        },
        fields: {
          id: 'رقم الإشعار',
          'title': 'عنوان الإشعار',
          'message': 'محتوى الإشعار',
          'image': 'صوره الإشعار (إختياري)',
          'name': 'اسم الإشعار (إختياري)',
          'placeId': 'PlaceId',
          createdAt: 'انشاء فى ',
          updatedAt: 'تعديل فى ',
          createdAtRange: 'Created at',
        },
        enumerators: {
  
        },
        new: {
          title: ' الإشعارات',
        },
        view: {
          title: 'عرض الإشعار',
        },
        importer: {
          title: 'Import Notifications',
          fileName: 'notification_import_template',
          hint:
            'Files/Images columns must be the URLs of the files separated by space.',
        },
      },
    },
  
    "auth": {
      "profile": {
        "title": "تعديل الملف الشخصي",
        "success": "تم تعديل الملف الشخصي بنجاح"
      },
      "createAnAccount": "إنشاء حساب جديد",
      "rememberMe": "تذكرنى",
      "forgotPassword": "لا أتذكر  كلمة المرور ؟",
      "resetPassword": "اعادة تعيين كلمة السر",
      "resetMessage": "لـ {0}",
      "newPassword": "كلمة المرور الجديدة",
      "authResetPassword": "أدخل كلمة المرور الجديدة هنا",
      "signin": "تسجيل الدخول",
      "signup": "إنشاء حساب ",
      "signout": "تسجيل الخروج",
      "google": "جوجل",
      "facebook": "فيسبوك",
      "twitter": "تويتر",
      "alreadyHaveAnAccount": "بالفعل لدى حساب ؟ تسجيل دخول",
      "signinWithAnotherAccount": "تسجيل دخول بحساب اخر ",
      "emailUnverified": {
        "message": "قم بتاكيد بريد الإلكتروني  <strong>{0}</strong> للاستكمال",
        "submit": "إعادة إرسال بريد الكترونى",
        "verifyAccount": "تأكيد حسابك الشخصي"
      },
      "emptyPermissions": {
        "message": "ليس لديك صلاحية الان يرجى الانتظار لحين موافقة الادمن"
      },
      "AccountPermission": "إذن الدخول للحساب الشخصي",
      "authForgetReset": "أدخل بريدك الإلكتروني هنا  ",
      "requestReset": "إرسال",
      "forgetPassword": "نسيت كلمة المرور ؟",
      "forgetText": " أدخل بريدك الإلكتروني الذى تستخدمه لحسابك و نحن سوف نرسل لك رابط إاعاده تعيين كلمة المرور ",
      "cancel": "إالغاء",
      "passwordResetEmail": {
        "message": "إرسال كلمة المرور ",
        "error": "البريد الإلكتروني غير معروف "
      },
      "passwordReset": {
        "message": "إعادة تعين كلمة المرور"
      },
      "emailAddressVerificationEmail": {
        "error": "البريد الإلكتروني غير معروف "
      },
      "verificationEmailSuccess": "تم إرسال البريد الاكترونى التعرفى ",
      "passwordResetEmailSuccess": "تم إرسال كلمة المرور بنجاح",
      "passwordResetSuccess": "تم تعديل كلمة المرور بنجاح",
      "verifyEmail": {
        "success": "تم تاكيد البريد الإلكتروني بنجاح",
        "message": "لحظة ، يتم التحقق من بريدك الإلكتروني ..."
      }
    },
  
    roles: {
      owner: {
        label: 'مالك',
        description: 'Full access to all resources',
      },
      editor: {
        label: 'محرر',
        description: 'Edit access to all resources',
      },
      viewer: {
        label: 'مشاهد',
        description: 'View access to all resources',
      },
      auditLogViewer: {
        label: 'مشاهدة سجل التدقيق',
        description: 'Access to view audit logs',
      },
      iamSecurityReviewer: {
        label: 'مشاهدة الصلاحيات',
        description: `Full access to manage users roles`,
      },
      entityEditor: {
        label: 'Entity Editor',
        description: 'Edit access to all entities',
      },
      entityViewer: {
        label: 'Entity Viewer',
        description: 'View access to all entities',
      },
      placeEditor: {
        label: 'محرر مواقع',
        description: 'Edit access to Places',
      },
      placeViewer: {
        label: 'مشاهد مواقع',
        description: 'View access to Places',
      },
      notificationEditor: {
        label: 'محرر إشعارات',
        description: 'Edit access to Notifications',
      },
      notificationViewer: {
        label: 'مشاهد إشعارات',
        description: 'View access to Notifications',
      },
    },
  
    iam: {
      title: 'إدارة الهوية والوصول',
      menu: 'IAM',
      disable: 'تعطيل',
      disabled: 'عطًل',
      enabled: 'فعًل',
      enable: 'تفعيل',
      doEnableSuccess: 'تم تفعيل المستخدم بنجاح',
      doDisableSuccess: 'تم تعطيل المستخدم بنجاح',
      doDisableAllSuccess: 'تم تعطيل المستخدمين بنجاح',
      doEnableAllSuccess: 'تم تفعيل المستخدمين بنجاح',
      doAddSuccess: 'تم حفظ المستخدم (المستخدمين) بنجاح',
      doUpdateSuccess: 'تم حفظ المستخدم بنجاح',
      viewBy: 'عرض بواسطة',
      users: {
        name: 'users',
        label: 'المستخدمين',
        exporterFileName: 'users_export',
        doRemoveAllSelectedSuccess:
          'تمت إزالة الأذونات بنجاح',
      },
      roles: {
        label: 'الأدوار',
        doRemoveAllSelectedSuccess:
          'تمت إزالة الأذونات بنجاح',
      },
      edit: {
        title: 'تعديل المستخدم',
        titleGuide:'تعديل ملف المرشد السياحي',
      },
      new: {
        title: 'مشرف جديد',
        titleGuide: 'مرشد سياحى جديد',
        titleUser: 'مستخدم جديد',
        emailsHint:
          'إفصل بين عناوين البريد الإلكتروني المتعددة باستخدام الحرف الفاصلة',
      },
      view: {
        title: 'عرض ملف المستخدم',
        titleGuide:'عرض ملف المرشد السياحي',
        activity: 'نشاطات',
      },
      importer: {
        title: 'استيراد المستخدمين',
        fileName: 'users_import_template',
        hint:
          'Files/Images columns must be the URLs of the files separated by space. Relationships must be the ID of the referenced records separated by space. Roles must be the role ids separated by space.',
      },
      errors: {
        userAlreadyExists:
          'لمستخدم بهذا البريد الإلكتروني موجود بالفعل',
        userNotFound: 'المستخدم ليس موجود',
        disablingHimself: `لا يمكنك تعطيل نفسك`,
        revokingOwnPermission: `لا يمكنك إلغاء إذن مالكك الخاص`,
      },
    },
  
    user: {
      fields: {
        id: 'رقم المستخدم',
        authenticationUid: 'مصادقة Uid',
        avatars: 'الصورة',
        email: 'البريد الإلكتروني',
        emails: 'البريد الإلكتروني',
        fullName: 'الإسم كامل',
        firstName: 'الإسم الاول',
        lastName: 'الإسم الاخير',
        status: 'الحالة',
        disabled: 'معطل',
        phoneNumber: 'رقم الجوال',
        countryCode: 'كود البلد',
        lang:'اللغة',
        role: 'الدور',
        createdAt: 'انشاء فى ',
          updatedAt: 'تعديل فى ',
        roleUser: 'دور / المستخدم',
        roles: 'الصلاحيات',
        accountType: 'نوع المستخدم',
        createdAtRange: 'أنشئت في',
        password: 'كلمة المرور',
        rememberMe: 'تذكرني',
      },
      enabled: 'مفعل',
      disabled: 'معطل',
      validations: {
        // eslint-disable-next-line
        email: 'البريد الإلكتروني $ {value} غير صالح',
      },
    },
  
    auditLog: {
      menu: 'سجلات التدقيق',
      title: 'سجلات التدقيق',
      exporterFileName: 'audit_log_export',
      entityNamesHint:
        'افصل بين الكيانات المتعددة باستخدام الحرف الفاصلة',
      fields: {
        id: 'رقم السجل',
        timestampRange: 'فترة',
        entityName: 'كيان',
        entityNames: 'كيانات',
        entityId: 'Entity ID',
        action: ' الأوامر',
        values: 'قيم',
        timestamp: 'تاريخ',
        createdByEmail: 'البريد الإلكتروني للمستخدم',
      },
    },
    settings: {
      title: 'الإعدادات',
      menu: 'الإعدادات',
      save: {
        success:
          'تم حفظ الإعدادات بنجاح. ستتم إعادة تحميل الصفحة في {0} ثانية لتصبح التغييرات نافذة المفعول.',
      },
      fields: {
        theme: 'Theme',
      },
      colors: {
        default: 'Default',
        cyan: 'Cyan',
        'geek-blue': 'Geek Blue',
        gold: 'Gold',
        lime: 'Lime',
        magenta: 'Magenta',
        orange: 'Orange',
        'polar-green': 'Polar Green',
        purple: 'Purple',
        red: 'Red',
        volcano: 'Volcano',
        yellow: 'Yellow',
      },
    },

    errors: {
      backToHome: 'العودة إلى الرئيسية',
      403: `آسف ، لا يمكنك الوصول إلى هذه الصفحة`,
      404: 'عفوًا ، الصفحة التي قمت بزيارتها غير موجودة',
      500: 'عذرًا ، يبلغ الخادم عن خطأ',
      forbidden: {
        message: 'ممنوع',
      },
      validation: {
        message: 'حدث خطأ',
      },
      defaultErrorMessage: 'معذرة حدث خطأ',
    },
    // See https://github.com/jquense/yup#using-a-custom-locale-dictionary
    /* eslint-disable */
    validation: {
      mixed: {
        default: '$ {path} غير صالح',
        required: '$ {path} مطلوب',
        oneOf:
          'يجب أن يكون $ {path} إحدى القيم التالية: $ {values}',
        notOneOf:
          'يجب ألا يكون $ {path} إحدى القيم التالية: $ {values}',
        notType: ({ path, type, value, originalValue }) => {
          return `يجب أن يكون $ {path} $ {type}`;
        },
      },
      string: {
        length:
          'يجب أن يكون $ {path} أحرف $ {length} تمامًا',
        min: 'يجب أن يكون $ {path} على الأقل $ {min} حرفًا',
        max: 'يجب أن يكون $ {path} بحد أقصى $ {max} حرفًا',
        matches:
          'يجب أن يتطابق $ {path} مع ما يلي: "$ {regex}"',
        email: 'يجب أن يكون $ {path} بريدًا إلكترونيًا صالحًا',
        url: 'يجب أن يكون $ {path} عنوان URL صالحًا',
        trim: 'يجب أن يكون $ {path} عبارة عن جملة مقطوعة',
        lowercase: 'يجب أن يكون $ {path} سلسلة أحرف صغيرة',
        uppercase: 'يجب أن يكون $ {path} سلسلة أحرف كبيرة',
        selected: 'يجب تحديد $ {path}',
      },
      number: {
        min:
          'يجب أن يكون $ {path} أكبر من أو يساوي $ {min}',
        max: 'يجب أن يكون $ {path} أقل من أو يساوي $ {max}',
        lessThan: 'يجب أن يكون $ {path} أقل من $ {less}',
        moreThan: 'يجب أن يكون $ {path} أكبر من $ {more}',
        notEqual: 'يجب أن لا يكون $ {path} مساويًا لـ $ {notEqual}',
        positive: 'يجب أن يكون $ {path} رقمًا موجبًا',
        negative: 'يجب أن يكون $ {path} رقمًا سالبًا',
        integer: 'يجب أن يكون $ {path} عددًا صحيحًا',
        invalid: 'يجب أن يكون $ {path} رقمًا',
      },
      date: {
        min: 'يجب أن يكون حقل $ {path} أكبر من $ {min}',
        max: 'يجب أن يكون حقل $ {path} في وقت سابق عن $ {max}',
      },
      boolean: {},
      object: {
        noUnknown:
          'لا يمكن أن يحتوي حقل $ {path} على مفاتيح غير محددة في شكل الكائن',
      },
      array: {
        min: 'يجب أن يحتوي حقل $ {path} على عناصر $ {min} على الأقل',
        max:
          'يجب أن يحتوي حقل $ {path} على أقل من أو يساوي عناصر $ {max}',
      },
    },
    /* eslint-disable */
    fileUploader: {
      upload: 'رفع',
      image: 'يجب عليك تحميل صورة',
      size: 'الملف كبير جدا. الحجم الأقصى المسموح به هو {0',
      formats: `تنسيق غير صالح. يجب أن يكون '{0}'.`,
    },
    importer: {
      line: 'خط',
      status: 'الحالة',
      pending: 'قيد الانتظار',
      imported: 'مستورد',
      error: 'خطأ',
      total: `{0} مستورد ، {1} معلق و {2} مع وجود خطأ`,
      importedMessage: `تمت المعالجة {0} من {1}.`,
      noNavigateAwayMessage:
        'لا تنتقل بعيدًا عن هذه الصفحة أو سيتم إيقاف الاستيراد.',
      completed: {
        success:
          'اكتمل الاستيراد. تم استيراد جميع الصفوف بنجاح.',
        someErrors:
          'اكتملت المعالجة ، لكن تعذر استيراد بعض الصفوف.',
        allErrors: 'فشل الاستيراد. لا توجد صفوف صالحة.',
      },
      form: {
        downloadTemplate: 'قم بتنزيل القالب',
        hint:
          'أنقر أو إسحب الملف إلى هذه المنطقة للمتابعة',
      },
      list: {
        discardConfirm:
          'هل أنت واثق؟ سيتم فقدان البيانات غير المستوردة.',
      },
      errors: {
        invalidFileEmpty: 'الملف فارغ',
        invalidFileExcel:
          'يُسمح فقط بملفات excel (.xlsx)',
        invalidFileUpload:
          'ملف غير صالح. تأكد من أنك تستخدم الإصدار الأخير من القالب.',
        importHashRequired: 'استيراد التجزئة هو مطلوب',
        importHashExistent: 'تم بالفعل استيراد البيانات',
      },
    },
  
    autocomplete: {
      loading: 'جار التحميل..',
    },
  
    imagesViewer: {
      noImage: 'لا توجد صورة',
    },
  
    firebaseErrors: {
      'auth/user-disabled': 'حسابك معطل',
      'auth/user-not-found': `آسف ، نحن لا نتعرف على بيانات الاعتماد الخاصة بك`,
      'auth/wrong-password': `آسف ، نحن لا نتعرف على بيانات الاعتماد الخاصة بك`,
      'auth/weak-password': 'كلمة المرور هذه ضعيفة جدًا',
      'auth/email-already-in-use': 'البريد الإلكتروني قيد الاستخدام بالفعل',
      'auth/invalid-email': 'يرجى تقديم عنوان بريد إلكتروني صالح',
      'auth/account-exists-with-different-credential':
        'البريد الإلكتروني مستخدم بالفعل لطريقة مصادقة مختلفة.',
      'auth/credential-already-in-use':
        'بيانات الاعتماد قيد الاستخدام بالفعل',
    },

    privacyPolicy: {
      p_1: `قامت شركة سارية بتصميم تطبيق سارية كتطبيق تجاري. يتم توفير هذه الخدمة من قبل شركة سارية وهي مخصصة للاستخدام كما هي.`,
      p_2: `تُستخدم هذه الصفحة لإعلام الزوار فيما يتعلق بسياساتنا فيما يتعلق بجمع المعلومات الشخصية واستخدامها والكشف عنها إذا قرر أي شخص استخدام خدمتنا.
      `,      
      p_3: `إذا اخترت استخدام خدمتنا ، فأنت توافق على جمع المعلومات واستخدامها فيما يتعلق بهذه السياسة. يتم استخدام المعلومات الشخصية التي نجمعها لتوفير الخدمة وتحسينها. لن نستخدم أو نشارك معلوماتك مع أي شخص باستثناء ما هو موضح في سياسة الخصوصية هذه.
      `,      
      p_4: `إن المصطلحات المستخدمة في سياسة الخصوصية هذه لها نفس المعاني الموجودة في الشروط والأحكام الخاصة بنا ، والتي يمكن الوصول إليها في سارية ما لم يتم تحديد خلاف ذلك في سياسة الخصوصية هذه.
      `,      
      p_5: `جمع المعلومات واستخدامها`,      
      p_6: `للحصول على تجربة أفضل ، أثناء استخدام خدمتنا ، قد نطلب منك تزويدنا ببعض المعلومات المحددة للهوية الشخصية. سنحتفظ بالمعلومات التي نطلبها واستخدامها كما هو موضح في سياسة الخصوصية هذه.`,      
      p_7: `يستخدم التطبيق خدمات الطرف الثالث التي قد تجمع المعلومات المستخدمة لتحديد هويتك.`,      
      p_8: `رابط إلى سياسة الخصوصية لموفري خدمة الطرف الثالث المستخدمة من قبل التطبيق
      `,      
      p_9: `تسجيل البيانات`,      
      p_10: `نريد إبلاغك أنه كلما استخدمت خدمتنا ، في حالة وجود خطأ في التطبيق ، نقوم بجمع البيانات والمعلومات (من خلال منتجات الطرف الثالث) على هاتفك تسمى Log Data. قد تتضمن بيانات السجل هذه معلومات مثل عنوان بروتوكول الإنترنت ("IP" الخاص بجهازك ، واسم الجهاز ، وإصدار نظام التشغيل ، وتكوين التطبيق عند استخدام خدمتنا ، ووقت وتاريخ استخدامك للخدمة ، وإحصاءات أخرى .
      `,      
      p_11: `ملفات تعريف الارتباط`,      
      p_12: `ملفات تعريف الارتباط هي ملفات تحتوي على كمية صغيرة من البيانات التي يتم استخدامها بشكل شائع كمعرفات فريدة مجهولة الهوية. يتم إرسالها إلى متصفحك من مواقع الويب التي تزورها ويتم تخزينها على الذاكرة الداخلية لجهازك.`,      
      p_13: `لا تستخدم هذه الخدمة "ملفات تعريف الارتباط" هذه بشكل صريح. ومع ذلك ، قد يستخدم التطبيق رمزًا ومكتبات تابعة لجهة خارجية تستخدم "ملفات تعريف الارتباط" لجمع المعلومات وتحسين خدماتها. لديك خيار إما قبول أو رفض ملفات تعريف الارتباط هذه ومعرفة متى يتم إرسال ملف تعريف ارتباط إلى جهازك. إذا اخترت رفض ملفات تعريف الارتباط الخاصة بنا ، فقد لا تتمكن من استخدام بعض أجزاء هذه الخدمة.
      `,      
      p_14: `مزودي الخدمة`,      
      p_15: ` يجوز لنا توظيف شركات وأفراد من جهات خارجية للأسباب التالية:`,   
      p_16: `لتسهيل خدمتنا`,   
      p_17: `لأداء الخدمات المتعلقة بالخدمة ؛ أو`,   
      p_18: `لتقديم الخدمة نيابة عنا ؛`,   
      p_19: `لمساعدتنا في تحليل كيفية استخدام خدمتنا.`,   
      p_20: `نريد إبلاغ مستخدمي هذه الخدمة بأن هذه الأطراف الثالثة يمكنها الوصول إلى معلوماتك الشخصية. والسبب هو أداء المهام المسندة إليهم نيابة عنا. ومع ذلك ، فإنهم ملزمون بعدم الكشف عن المعلومات أو استخدامها لأي غرض آخر.`,   
      p_21: `الأمان`,   
      p_22: `نحن نقدر ثقتك في تزويدنا بمعلوماتك الشخصية ، وبالتالي نسعى جاهدين لاستخدام وسائل مقبولة تجاريًا لحمايتها. ولكن تذكر أنه لا توجد طريقة إرسال عبر الإنترنت ، أو طريقة تخزين إلكترونية آمنة وموثوق بها بنسبة 100٪ ، ولا يمكننا ضمان أمانها المطلق.
      `,   
      p_23: `روابط لمواقع أخرى`,   
      p_24: `قد تحتوي هذه الخدمة على روابط لمواقع أخرى. إذا قمت بالنقر فوق ارتباط جهة خارجية ، فسيتم توجيهك إلى هذا الموقع. لاحظ أن هذه المواقع الخارجية لا نقوم بتشغيلها. لذلك ، ننصحك بشدة بمراجعة سياسة الخصوصية لهذه المواقع. لا نتحكم ولا نتحمل أي مسؤولية عن المحتوى أو سياسات الخصوصية أو الممارسات الخاصة بأي مواقع أو خدمات تابعة لجهات خارجية.`,   
      p_25: `خصوصية الأطفال`,   
      p_26: `لا تتعامل هذه الخدمات مع أي شخص يقل عمره عن 13 عامًا. نحن لا نجمع عن قصد معلومات تحديد الهوية الشخصية من الأطفال تحت سن 13 عامًا. في حالة اكتشافنا أن طفلًا أقل من 13 عامًا قدم لنا معلومات شخصية ، فإننا نحذفها على الفور من خوادمنا. إذا كنت أحد الوالدين أو الوصي وكنت على علم بأن طفلك قدم لنا معلومات شخصية ، يرجى الاتصال بنا حتى نتمكن من القيام بالإجراءات اللازمة.
      `,   
      p_27: `التغييرات على سياسة الخصوصية هذه`,   
      p_28: `قد نقوم بتحديث سياسة الخصوصية الخاصة بنا من وقت لآخر. وبالتالي ، ننصحك بمراجعة هذه الصفحة بشكل دوري لأية تغييرات. سنقوم بإعلامك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة.
      `,   
      p_29: `تسري هذه السياسة اعتبارًا من 2020-04-17
      `,   
      p_30: `تواصل معنا`,   
      p_31: `إذا كان لديك أي أسئلة أو اقتراحات حول سياسة الخصوصية الخاصة بنا ، فلا تتردد في الاتصال بنا على info@saryahapp.com.
      `,   
    },

    termsAndConditions: {
      p_1: `من خلال تنزيل التطبيق أو استخدامه ، سيتم تطبيق هذه الشروط عليك تلقائيًا - يجب عليك التأكد من قراءتها بعناية قبل استخدام التطبيق. لا يُسمح لك بنسخ أو تعديل التطبيق أو أي جزء من التطبيق أو علاماتنا التجارية بأي شكل من الأشكال. لا يُسمح لك بمحاولة استخراج شفرة المصدر للتطبيق ، ولا ينبغي لك أيضًا محاولة ترجمة التطبيق إلى لغات أخرى ، أو إنشاء إصدارات مشتقة. التطبيق نفسه ، وجميع العلامات التجارية وحقوق التأليف والنشر وحقوق قواعد البيانات وحقوق الملكية الفكرية الأخرى المتعلقة به ، لا تزال تنتمي إلى سارية. `,
      p_2: `تلتزم سارية بضمان أن التطبيق مفيد وفعال قدر الإمكان. لهذا السبب ، نحتفظ بالحق في إجراء تغييرات على التطبيق أو فرض رسوم على خدماته ، في أي وقت ولأي سبب. لن نقوم أبدًا بتحصيل رسوم منك مقابل التطبيق أو خدماته دون أن نوضح لك تمامًا ما تدفعه مقابل ذلك.`,      
      p_3: `يقوم تطبيق سارية بتخزين ومعالجة البيانات الشخصية التي قدمتها لنا من أجل تقديم خدمتنا. تقع على عاتقك مسؤولية الحفاظ على هاتفك والوصول إلى التطبيق آمنًا. لذلك ، نوصي بعدم كسر حماية الهاتف أو القضاء عليه ، وهي عملية إزالة قيود البرامج والقيود التي يفرضها نظام التشغيل الرسمي لجهازك. يمكن أن يجعل هاتفك عرضة للبرامج الضارة / الفيروسات / البرامج الضارة ، ويضر بميزات أمان هاتفك وقد يعني أن تطبيق سارية لن يعمل بشكل صحيح أو على الإطلاق.`,      
      p_4: `يستخدم التطبيق خدمات الطرف الثالث التي تعلن الشروط والأحكام الخاصة بها. `,      
      p_5: `رابط إلى شروط وأحكام مزودي الخدمة التابعين للجهات الخارجية الذين يستخدمهم التطبيق      `,      
      p_6: `يجب أن تدرك أن هناك أشياء معينة لن تتحملها سارية. تتطلب وظائف معينة في التطبيق أن يكون للتطبيق اتصال إنترنت نشط. يمكن أن يكون الاتصال Wi-Fi ، أو مقدمًا من قبل مزود شبكة الهاتف المحمول الخاص بك ، ولكن لا يمكن لـ Saryah تحمل مسؤولية عدم عمل التطبيق بكامل وظائفه إذا لم يكن لديك وصول إلى Wi-Fi ، ولم يكن لديك أي ترك بدل البيانات.      `,      
      p_7: `إذا كنت تستخدم التطبيق خارج منطقة مزودة بشبكة Wi-Fi ، يجب أن تتذكر أن شروط الاتفاقية الخاصة بك مع مزود شبكة الهاتف المحمول ستظل سارية. ونتيجة لذلك ، قد يفرض موفر خدمة الجوال الخاص بك رسومًا على تكلفة البيانات طوال مدة الاتصال أثناء الوصول إلى التطبيق ، أو رسوم الطرف الثالث الأخرى. عند استخدام التطبيق ، فأنت تقبل المسؤولية عن أي رسوم من هذا القبيل ، بما في ذلك رسوم بيانات التجوال إذا كنت تستخدم التطبيق خارج منطقتك المحلية (أي المنطقة أو البلد) دون إيقاف تجوال البيانات. إذا لم تكن دافع الفواتير للجهاز الذي تستخدم التطبيق عليه ، فيرجى العلم أننا نفترض أنك تلقيت إذنًا من دافع الفواتير لاستخدام التطبيق.      `,      
      p_8: `على نفس المنوال ، لا يمكن لسارية دائمًا تحمل المسؤولية عن الطريقة التي تستخدم بها التطبيق ، أي أنك تحتاج إلى التأكد من أن جهازك يظل مشحونًا - إذا نفد شحن البطارية ولا يمكنك تشغيله للاستفادة من الخدمة ، لا يمكن لسارية قبول المسؤولية.      `,      
      p_9: `فيما يتعلق بمسؤولية سارية عن استخدامك للتطبيق ، عند استخدام التطبيق ، من المهم أن تضع في اعتبارك أنه على الرغم من سعينا لضمان تحديثه وتصحيحه في جميع الأوقات ، فإننا نعتمد على جهات خارجية لتوفير معلومات لنا حتى نتمكن من إتاحتها لك. لا يقبل سارية أي مسؤولية عن أي ختواصل معنا ، مباشرة أو غير مباشرة ، تواجهها نتيجة الاعتماد بالكامل على هذه الوظيفة للتطبيق.      `,      
      p_10: `في وقت ما ، قد نرغب في تحديث التطبيق. التطبيق متاح حاليًا على نظام التشغيل Android iOS - قد تتغير متطلبات كلا النظامين (وأي أنظمة إضافية نقرر تمديد توافر التطبيق إليها) ، وستحتاج إلى تنزيل التحديثات إذا كنت ترغب في الاستمرار في استخدام تطبيق. لا تعد سارية بأنها ستقوم دائمًا بتحديث التطبيق بحيث يكون مناسبًا لك و / أو يعمل مع إصدار Android iOS الذي قمت بتثبيته على جهازك. ومع ذلك ، فإنك تتعهد بقبول تحديثات التطبيق دائمًا عند تقديمها لك ، وقد نرغب أيضًا في التوقف عن تقديم التطبيق ، وقد ننهي استخدامه في أي وقت دون إشعارك بالإنهاء.
      ما لم نخبرك بخلاف ذلك ، عند أي إنهاء ، (أ) ستنتهي الحقوق والتراخيص الممنوحة لك في هذه الشروط (ب) يجب عليك التوقف عن استخدام التطبيق ، و (إذا لزم الأمر) حذفه من جهازك.`,      
      p_11: `التغييرات على هذه الشروط والأحكام      `,      
      p_12: `قد نقوم بتحديث الشروط والأحكام الخاصة بنا من وقت لآخر. وبالتالي ، ننصحك بمراجعة هذه الصفحة بشكل دوري لأية تغييرات. سنقوم بإعلامك بأي تغييرات عن طريق نشر الشروط والأحكام الجديدة على هذه الصفحة.      `,      
      p_13: `تسري هذه الشروط والأحكام اعتبارًا من 2020-07-07      `,      
      p_14: `تواصل معنا`,      
      p_15: `إذا كان لديك أي أسئلة أو اقتراحات حول الشروط والأحكام الخاصة بنا ، فلا تتردد في الاتصال بنا على info@saryahapp.com.      `,      
    },


  };
  
  export default ar;
  